/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FieldMappingEntry } from './FieldMappingEntry';
import {
    FieldMappingEntryFromJSON,
    FieldMappingEntryFromJSONTyped,
    FieldMappingEntryToJSON,
} from './FieldMappingEntry';

/**
 * 
 * @export
 * @interface SaveFieldMappingRequest
 */
export interface SaveFieldMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveFieldMappingRequest
     */
    stotlesObjectType: SaveFieldMappingRequestStotlesObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveFieldMappingRequest
     */
    entityName: string;
    /**
     * 
     * @type {Array<FieldMappingEntry>}
     * @memberof SaveFieldMappingRequest
     */
    fields: Array<FieldMappingEntry>;
}


/**
 * @export
 */
export const SaveFieldMappingRequestStotlesObjectTypeEnum = {
    Lead: 'LEAD',
    Bid: 'BID',
    Contact: 'CONTACT'
} as const;
export type SaveFieldMappingRequestStotlesObjectTypeEnum = typeof SaveFieldMappingRequestStotlesObjectTypeEnum[keyof typeof SaveFieldMappingRequestStotlesObjectTypeEnum];


/**
 * Check if a given object implements the SaveFieldMappingRequest interface.
 */
export function instanceOfSaveFieldMappingRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stotlesObjectType" in value;
    isInstance = isInstance && "entityName" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function SaveFieldMappingRequestFromJSON(json: any): SaveFieldMappingRequest {
    return SaveFieldMappingRequestFromJSONTyped(json, false);
}

export function SaveFieldMappingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveFieldMappingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stotlesObjectType': json['stotlesObjectType'],
        'entityName': json['entityName'],
        'fields': ((json['fields'] as Array<any>).map(FieldMappingEntryFromJSON)),
    };
}

export function SaveFieldMappingRequestToJSON(value?: SaveFieldMappingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stotlesObjectType': value.stotlesObjectType,
        'entityName': value.entityName,
        'fields': ((value.fields as Array<any>).map(FieldMappingEntryToJSON)),
    };
}

